import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import resourcesJson from "./locales/i18n.json";
import resourcesJsonV2 from "./locales/i18n_v2.json";

// Function to recursively process the JSON and split into languages
// We need a deep traversal that builds two distinct objects: one for en, one for zh.
const buildResources = (source: any) => {
  const en: any = {};
  const zh: any = {};

  const traverse = (node: any, enNode: any, zhNode: any) => {
    for (const key in node) {
      const value = node[key];
      if (typeof value === "object" && value !== null) {
        // Check if this is a translation leaf node (has exactly zh and en keys)
        // Note: some nodes might have zh/en AND other children, but based on the file viewing, it seems strict.
        // Let's assume if it has 'zh' and 'en' strings, it's a leaf.
        if (typeof value.zh === "string" && typeof value.en === "string") {
          enNode[key] = value.en;
          zhNode[key] = value.zh;
        } else {
          // It's a namespace or nested object
          enNode[key] = {};
          zhNode[key] = {};
          traverse(value, enNode[key], zhNode[key]);
        }
      }
    }
  };

  traverse(source, en, zh);
  return { en, zh };
};

// Simple deep merge function
const deepMerge = (target: any, ...sources: any[]): any => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (
    typeof target === "object" &&
    target !== null &&
    typeof source === "object" &&
    source !== null
  ) {
    for (const key in source) {
      if (typeof source[key] === "object" && source[key] !== null) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
};

const { en: legacyEn, zh: legacyZh } = buildResources(resourcesJson);
const { en: newEn, zh: newZh } = buildResources(resourcesJsonV2);

const finalEn = deepMerge({}, legacyEn, newEn);
const finalZh = deepMerge({}, legacyZh, newZh);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: finalEn,
      },
      zh: {
        translation: finalZh,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // order: ["localStorage", "navigator"],
      order: ["localStorage"],
      lookupLocalStorage: "i18n",
      caches: ["localStorage"],
    },
  });

export default i18n;
